'use client';

import { useStore } from '@/providers/app-store-provider';
import { IS_US } from '@/utils/constants';

interface PublicResourceLike {
  jsonvalues?: {
    compliance_subscription_display?: {
      switch?: number | string;
    };
  };
}

/**
 * 展示规则
 *
 * 需求文档：营销同意/退出/限制-20260302
 * https://alidocs.dingtalk.com/i/nodes/jb9Y4gmKWr7Z3roEFQRwYynYVGXn6lpz?utm_scene=team_space
 *
 * 接口文档
 * https://app.apifox.com/project/1627105
 *
 * 冒烟文档：
 * https://alidocs.dingtalk.com/i/nodes/ZX6GRezwJl7NdjoEFrx7bgK5VdqbropQ?utm_scene=team_space
 *
 * 原型链接：
 * https://modao.cc/proto/0V9uQyWt4kjnsYSmFQrHu/sharing?view_mode=read_only&screen=rbpVCxFfULjKkHc8a
 *
 * 设计稿：
 * https://lanhuapp.com/web/#/item/project/stage?pid=7c494c6e-4d67-4a95-8050-4bafdf24ab53&image_id=4eb4ba92-0d11-4e48-80f6-09b0e4e24465&tid=6baa5793-8f5f-47ca-9062-2ada6a07fec3
 */
export const useComplianceSubscriptionDisplay = () => {
  const token = useStore((state) => state.token);
  const publicResourceData = useStore((state) => state.publicResourceData as PublicResourceLike);
  const marketingStatus = useStore((state) => state.complianceMarketingStatus);

  const isSubscriptionDisplayEnabled = (() => {
    // 非北美站、未登录不展示
    if (!IS_US || !token) return false;

    const config = publicResourceData?.jsonvalues?.compliance_subscription_display || {};
    const switchValue = config.switch;

    if (!switchValue) return false;
    return switchValue === 1 || switchValue === '1';
  })();

  if (!isSubscriptionDisplayEnabled || marketingStatus === undefined) {
    return {
      isShowSubscribeEmail: false,
      isShowSubscribePhone: false,
      isShowSubscribe_EditAddress_Phone: false,
      isShowSubscribeEmail_ChangedEmailForm: false,
    };
  }

  const granted = marketingStatus?.marketing_granted;

  return {
    isShowSubscribeEmail: !granted?.email, // 仅向【邮箱营销同意】状态非同意的登录用户展示
    isShowSubscribePhone: !(granted?.sms && granted?.phone), // 仅向【电话号码营销同意】状态非同意的登录用户展示
    isShowSubscribe_EditAddress_Phone: true, // 常驻展示
    isShowSubscribeEmail_ChangedEmailForm: true, // 在修改邮箱的场景下, 为常驻选项
  };
};

export default useComplianceSubscriptionDisplay;
